export default __webpack_public_path__ + "static/media/frutiger-45light.a561370e.eot";